<template>
  <div class="link-add" v-loading="pageLoading">
    <div class="bread">
      {{ form.id ? "编辑" : "添加" }}环节—{{
        linkInfo.nodeDesc ? linkInfo.nodeDesc : linkInfo.nodeTypeDesc
      }}
      <el-button plain size="small" icon="el-icon-arrow-left" @click="tabChange5">返回</el-button>
    </div>
    <div class="link-form">
      <el-form class="link-add-form" ref="linkForm" :rules="rules" :model="form" label-width="135px" size="small">
        <el-form-item label="环节名称" prop="topic">
          <el-input maxlength="20" show-word-limit v-model="form.topic" style="width: 400px"></el-input>
        </el-form-item>
        <el-form-item label="环节说明" prop="remark">
          <el-input maxlength="200" show-word-limit v-model="form.remark" style="width: 600px" type="textarea"
                    :autosize="{ minRows: 5, maxRows: 8 }" placeholder="请输入环节说明,200字以内。"></el-input>
        </el-form-item>
        <!-- 上传 -->
        <el-form-item v-if="!['eval', 'survey', 'homework'].includes(linkInfo.nodeType)" label="文件" prop="attaches">
          <upload-link ref="linkBatchImport" accept="*" :fileLimit="15" @changeUpload="changeUpload" @uploadloading="uploadloading"
                       :fileList="form.attaches">
            <template slot="body">
              <el-button :loading="btnLoading" size="small" type="primary">点击上传</el-button>
            </template>
          </upload-link>
        </el-form-item>
        <!-- 评价表 -->
        <el-form-item v-if="!pageLoading && linkInfo.nodeType == 'eval' && evalTemList.length > 0" label="评价表"
                      prop="evalTempCodes">
          <el-checkbox-group v-model="form.evalTempCodes">
            <div v-for="i in evalTemList" :key="i.tempCode">
              <el-checkbox :label="i.tempCode" :key="i.tempCode">{{
                i.tempName
              }}</el-checkbox>
            </div>
          </el-checkbox-group>
        </el-form-item>
        <!-- //问卷 -->
        <el-form-item v-if="linkInfo.nodeType == 'survey'" prop="surveyList">
          <div class="wj-info">
            <el-button type="text" @click="dialogWjShow">添加问卷</el-button>
            <el-row type="flex" align="middle" v-for="i in surveyList" :key="i.id">
              <el-col :span="10">
                <h1>{{ customSurvey(i) }}</h1>
                <h2>{{ i.updateTime || i.createTime }}</h2>
              </el-col>
              <el-col :span="14" align="right">
                <el-button class="wj-btn-edit" type="text" @click="surveyEdit(i.id)">编 辑</el-button>
                <el-button class="wj-btn-del" type="text" @click="surveyDel(i.id)">删 除</el-button>
              </el-col>
            </el-row>
          </div>
        </el-form-item>
        <!-- //培训作业 -->
        <el-form-item v-if="linkInfo.nodeType == 'homework'" label="是否公开培训作业" prop="isOpen">
          <el-radio-group v-model="form.isOpen">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <div>
          <el-button :loading="subLoding" class="sub-btn" type="primary" size="small" @click="subLink">提 交</el-button>
        </div>
      </el-form>
    </div>
    <!-- 问卷调查 -->
    <dialog-survey v-if="dialogWj" :surveyTypeOptions="surveyTypeOptions" :wjformPro="wjformLink" :dialogWj="dialogWj"
                   @dialogWjClose="dialogWjClose" @surveyChange="surveyChange"></dialog-survey>
  </div>
</template>
<script>
import { getCurrentDate } from "@/utils/index.js";
import { postData, getData, postJson } from "@/http/fetch.js";
import UploadLink from "@/components/upload/UploadLink.vue";
import PopupDel from "@/components/PopupDel.vue";
import DialogSurvey from "@/components/dialog/DialogSurvey.vue";
import { mapState } from "vuex";
export default {
  components: {
    UploadLink,
    PopupDel,
    DialogSurvey,
  },
  props: {
    linkInfo: {
      require: true,
    },
    moduleType: "", //eduResearch 教研活动 	train 培训  topicResearch 项目课题研究 researchGroupTopic 教研组活动
    //  "document": //文档
    // 	"image": //图片
    // 	"media": //音视频
    // 	"speak": //发言讨论
    // 	"eval": //评价
    // 	"survey": //问卷调查
  },
  computed: {
    ...mapState(["userInfo", "resOptions"]),
  },
  data() {
    let validateSurveyList = (rule, value, callback) => {
      if (this.surveyList.length === 0) {
        callback(new Error("请添加问卷！"));
      } else {
        callback();
      }
    };
    return {
      pageLoading: true,
      subLoding: false,
      btnLoading: false,
      form: {
        topic: "", //主题
        remark: "", //说明
        isSub: 0, //是否是子活动节点，0：否，1：是     只有项目课题研究是1
        isOpen: "", //培训作业是否公开，1：是，0：否
        evalTempCodes: [], //评价表 显示
        evalTemplates: [], //[{ evalCode: "", tempCode: "" }]关联评价模板信息
        attaches: [], //附件
        operatorId: "",
        actCode: "",
        nodeCode: "", //本环节id
        nodeType: "",

        nodeTopicSurveyForms: [], //调查问卷
      },
      rules: {
        topic: [{ required: true, message: "请输入环节名称", trigger: "blur" }],
        isOpen: [{ required: true, message: "请选择是否公开培训作业", trigger: "blur" }],
        // remark: [{ required: true, message: "请输入环节说明", trigger: "blur" }],
        // attaches: [{ required: true, message: "请选择文件", trigger: "blur" }],
        evalTempCodes: [{ required: true, message: "请选择评价表", trigger: "blur" }],
        surveyList: [{ validator: validateSurveyList, trigger: "blur" }],
      },
      //评级
      evalTemList: [],
      //问卷调查
      dialogWj: false,
      surveyTypeOptions: [
        { value: "dy", label: "调研" },
        { value: "tp", label: "投票" },
        { value: "zdy", label: "自定义" },
      ],
      surveyList: [],
      wjformLink: {
        surveyType: "",
        customSurvey: "",
        questionDTOS: [
          {
            id: 1,
            question: "",
            quesType: "lonely",
            quesOption: [{ id: 1, order: "A", desc: "" }],
          },
        ],
      },
    };
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      this.pageLoading = true;
      //普通环节  不是 课题研究
      if (!this.linkInfo.contentId && this.linkInfo.nodeCode) {
        //编辑
        let nodeTopic = await postData("/node/getActiveNodeTopic", {
          nodeCode: this.linkInfo.nodeCode,
          operateId: this.userInfo.userId,
          schoolCode: this.userInfo.orgCode || this.userInfo.schoolCode
        });
        this.form = { ...nodeTopic };
        if (nodeTopic.attaches && nodeTopic.attaches.length > 0) {
          nodeTopic.attaches.forEach((i) => {
            i.name =
              i.attachName ||
              i.attachUrl.substring(i.attachUrl.lastIndexOf("/") + 1, i.attachUrl.length);
          });
        }

        if (this.form.evalTemplate && this.form.evalTemplate.length > 0) {
          this.$set(
            this.form,
            "evalTempCodes",
            this.form.evalTemplate.map((i) => i.tempCode)
          );
        } else {
          this.$set(this.form, "evalTempCodes", []);
        }
        //调查问卷
        if (this.linkInfo.nodeType == "survey") {
          let surveyList = await postJson("/node/getNodeTopicSurveyQuestionList", {
            actCode: sessionStorage.getItem("actCode"),
            nodeCode: this.linkInfo.nodeCode,
            operatorId: this.userInfo.userId,
          });
          surveyList.forEach((item) => {
            item.questionList.forEach((i) => {
              i.quesOption = JSON.parse(i.quesOption);
            });
            item.questionDTOS = item.questionList;
          });
          this.surveyList = surveyList;
        }
      }
      //活动评价模板
      if (this.linkInfo.nodeType == "eval") {
        let arr = await postData("/node/getSysTemplateInfo", {
          schoolCode: this.userInfo.orgCode || this.userInfo.schoolCode,
        });

        // if(this.userInfo.orgCode == 'FJYFX'){
        //   if (this.moduleType == "eduResearch") {
        //     arr =  arr.filter((f) => {
        //     return f.tempType == 'quality_ast_drkt';
        //     })
        //   }
        //   if (this.moduleType == "train") {
        //     arr = arr.filter((f) => {
        //     return f.tempType == 'quality_ast_mdjt';
        //     })
        //   }
        // }else{

        // }
        this.evalTemList = arr;
      }
      //项目课题研究 回显
      if (this.linkInfo.contentId && this.linkInfo.nodeCode) {
        this.form.topic = this.linkInfo.topic; //主题
        this.form.remark = this.linkInfo.remark; //说明
        this.form.isSub = 1; //是否是子活动节点，0：否，1：是     只有项目课题研究是1
        this.form.isOpen = ""; //培训作业是否公开，1：是，0：否
        this.form.evalTempCodes = []; //评价表 显示
        this.form.evalTemplates = []; //[{ evalCode: "", tempCode: "" }]关联评价模板信息
        this.form.attaches = this.linkInfo.attaches; //附件
        this.form.operatorId = "";
        this.form.actCode = "";
        this.form.nodeCode = ""; //本环节id
        this.form.nodeType = this.linkInfo.nodeType;
        this.form.nodeTopicSurveyForms = []; //调查问卷
        this.form.tempId = this.linkInfo.tempId;
        if (this.form.attaches && this.form.attaches.length > 0) {
          this.form.attaches.forEach((i) => {
            i.name = i.attachUrl.substring(
              i.attachUrl.lastIndexOf("/") + 1,
              i.attachUrl.length
            );
          });
        }
      }

      this.pageLoading = false;
    },
    tabChange5() {
      if (this.moduleType == "topic") {
        //项目课题研究
        this.$emit("changTab", "eduForm");
      } else if (this.moduleType == "researchGroupTopic") {
        //教研组活动
        this.$emit("changTab", "eduForm");
      } else {
        this.$emit("changTab", "link");
      }
    },
    uploadloading(Bool) {
      this.subLoding = Bool;
      this.btnLoading = Bool;
    },
    changeUpload(fileList) {
      fileList.forEach((i) => {
        if (!i.name) {
          i.name = i.attachName;
        }
      });
      this.form.attaches = fileList;
    },
    async subLink() {
      //项目课题研究
      if (this.moduleType == "topic") {
        await this.$refs.linkForm.validate();
        this.topicSubLink();
      } else if (this.moduleType == "researchGroupTopic") {
        await this.$refs.linkForm.validate();
        this.subLoding = true;
        this.form.actCode = sessionStorage.getItem("actCode");
        this.form.nodeType = this.linkInfo.nodeType;
        this.form.operatorId = this.userInfo.userId;
        //评价表
        if (this.form.evalTempCodes && this.form.evalTempCodes.length > 0) {
          this.form.evalTemplates = [];
          this.form.evalTempCodes.forEach((i) => {
            this.form.evalTemplates.push({
              evalCode: "",
              tempCode: i,
            });
          });
        }
        //调查问卷
        if (this.linkInfo.nodeType == "survey") {
          this.surveyList.forEach((item) => {
            delete item.id;
            item.questionDTOS.forEach((i) => {
              delete i.id;
              i.quesOption = JSON.stringify(i.quesOption);
            });
          });
          this.form.nodeTopicSurveyForms = this.surveyList;
        }
        this.form.contentId = this.linkInfo.contentId;
        this.form.nodeType = this.linkInfo.nodeType;
        this.form.isSub = 0;
        if (!this.form.tempId) {
          //新增
          this.form.tempId = new Date().getTime(); //临时id
        }
        this.$store.commit("setTopicLink", this.form);
        this.$emit("changTab", "eduForm");
      } else {
        try {
          await this.$refs.linkForm.validate();
          this.subLoding = true;
          this.form.actCode = sessionStorage.getItem("actCode");
          this.form.nodeType = this.linkInfo.nodeType;
          this.form.operatorId = this.userInfo.userId;
          //评价表
          if (this.form.evalTempCodes && this.form.evalTempCodes.length > 0) {
            this.form.evalTemplates = [];
            this.form.evalTempCodes.forEach((i) => {
              this.form.evalTemplates.push({
                evalCode: "",
                tempCode: i,
              });
            });
          }
          //调查问卷
          if (this.linkInfo.nodeType == "survey") {
            this.surveyList.forEach((item) => {
              delete item.id;
              item.questionDTOS.forEach((i) => {
                delete i.id;
                i.quesOption = JSON.stringify(i.quesOption);
              });
            });
            this.form.nodeTopicSurveyForms = this.surveyList;
          }
          console.log("this.form.nodeTopicSurveyForms", this.form.nodeTopicSurveyForms);
          await postJson("/research/saveOrUpdateActiveNodeTopic", this.form);
          this.subLoding = false;
          this.$message.success("保存成功！");
          this.$emit("changTab", "link");
        } catch (err) {
          // this.$message.error("保存失败 ,请稍后重试 ！");
          console.log("err--subLink", err);
        }
      }
    },
    //添加问卷
    dialogWjShow() {
      this.wjformLink = {
        surveyType: "",
        customSurvey: "",
        questionDTOS: [
          {
            id: 1,
            question: "",
            quesType: "lonely",
            quesOption: [{ id: 1, order: "A", desc: "" }],
          },
        ],
      };
      this.dialogWj = true;
    },
    dialogWjClose() {
      this.dialogWj = false;
    },
    surveyChange(survey) {
      if (survey.id) {
        //编辑
        let editSurvey = this.surveyList.find((i) => i.id === survey.id);
        editSurvey.surveyType = survey.surveyType;
        editSurvey.customSurvey = survey.customSurvey;
        editSurvey.questionDTOS = survey.questionDTOS;
        editSurvey.updateTime = getCurrentDate(2);
      } else {
        //新增
        survey.operatorId = this.userInfo.userId;
        survey.actCode = sessionStorage.getItem("actCode");
        survey.id = new Date().getTime();
        survey.updateTime = getCurrentDate(2);
        this.surveyList.push(survey);
      }
    },
    customSurvey(i) {
      if (i.surveyType == "zdy") {
        return i.customSurvey;
      } else {
        return this.surveyTypeOptions.find((item) => item.value == i.surveyType).label;
      }
    },
    surveyDel(id) {
      this.surveyList = this.surveyList.filter((i) => i.id != id);
    },
    surveyEdit(id) {
      let curSurvey = this.surveyList.find((i) => i.id === id);
      this.wjformLink.id = curSurvey.id;
      this.wjformLink.questionDTOS = curSurvey.questionDTOS;
      this.wjformLink.surveyType = curSurvey.surveyType;
      this.wjformLink.customSurvey = curSurvey.customSurvey;
      this.dialogWj = true;
    },
    //项目课题研究
    topicSubLink() {
      this.form.contentId = this.linkInfo.contentId;
      this.form.nodeType = this.linkInfo.nodeType;
      this.form.operatorId = this.userInfo.userId;
      this.form.isSub = 1;
      if (!this.form.tempId) {
        //新增
        this.form.tempId = new Date().getTime(); //临时id
      }
      this.$store.commit("setTopicLink", this.form);
      this.$emit("changTab", "eduForm");
    },
  },
};
</script>

<style lang="less" scoped>
.link-add {
  padding: 10px 0px;

  .bread {
    padding: 10px;
    padding-left: 30px;
    font-size: 15px;
    font-weight: 700;
    border-bottom: 2px solid #eee;

    .el-button {
      margin-left: 20px;
    }
  }

  .link-add-form {
    width: 800px;
    margin: 0 auto;
    margin-top: 35px;

    .sub-btn {
      margin-top: 80px;
      margin-left: 400px;
      margin-bottom: 50px;
    }
  }

  .wj-info {

    // border: 1px solid #000;
    .el-row {
      border: 1px solid rgb(192, 189, 189);
      padding: 5px 10px;
      padding-left: 15px;
      border-radius: 10px;
      background-color: #eee;
      margin: 10px 0px;

      .wj-btn-edit {
        margin: 0px 60px;
      }

      .wj-btn-del {
        color: @hong;
        margin-right: 60px;
      }

      .el-col:nth-of-type(1) {
        h1 {
          font-size: 14px;
          height: 26px;
          line-height: 26px;
          // border: 1px solid #000;
        }

        h2 {
          font-size: 12px;
          height: 15px;
          line-height: 15px;
          // border: 1px solid #000;
          color: @hui;
        }
      }
    }
  }
}
</style>
